import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { injectReportsHttpApiService } from '@core/reports-contracts';
import { ReportDashboardTemplatesResponse } from '@core/reports-types';

import { SharedAnalyticsReportsHttpApiService } from '../../services/reports-http-api.service';

@Injectable({ providedIn: 'root' })
export class ReportsDashboardTemplatesHttpClient {
  private readonly httpApi = injectReportsHttpApiService();

  public fetchCollection(): Observable<ReportDashboardTemplatesResponse> {
    const endpoint = this.isSharedAnalytics()
      ? '/templates/dashboards'
      : 'report/templates/dashboards';
    return this.httpApi.get(endpoint);
  }

  private isSharedAnalytics(): boolean {
    return this.httpApi instanceof SharedAnalyticsReportsHttpApiService;
  }
}
